import styles from './TitleAndTextInColumns.module.scss';

export type Props = {
  title: string;
  text: string;
};

const TitleAndTextInColumns = (props: Props): JSX.Element => {
  const { title, text } = props;
  return (
    <div className={styles.intro_capabilities}>
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={`medium_text ${styles.medium_text}`}>{title}</div>
        </div>
        <div
          className={`text_4 ${styles.description}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  );
};
export default TitleAndTextInColumns;
